const trackMateriel = {
  materialCode: '物料编码',
  productCode: '产品编码',
  productName: '产品名称',
  status: '状态',
  enabled: '是否启用',
  msg: {}
};
export default trackMateriel;



// WEBPACK FOOTER //
// ./src/page/md/trackMateriel/lang/trackMateriel.zh.js